<template>
	<b-card>
		<div class="hidden-print">
			<b-row>
				<b-col>
					<multiselect label="name" track-by="id" :multiple="false" :allow-empty="true" :group-select="true"
						:show-labels="false" :options="departments" v-model="departmentId" @select="disableOption"
						class="multiselect-pricing" :placeholder="$t('promo-to-product.department')" />
				</b-col>
				<b-col>
					<multiselect label="name" track-by="id" :multiple="true" :allow-empty="true" :group-select="true"
						:show-labels="false" :options="departments" v-model="departmentIds" :disabled="depDisabled"
						class="multiselect-pricing" :placeholder="$t('promo-to-product.department')" />
				</b-col>
				<b-col align="center">
					<b-checkbox v-model="allDep" class="mr-2" switch inline><b>{{ $t("Whole_firm") }}</b></b-checkbox>
					<b-button @click="getItems" :disabled="loading" variant="dark" class="fa fa-search mr-2 ml-2" />
					<vs-dropdown vs-custom-content vs-trigger-click>
						<b-link href.prevent class="card-header-action btn-setting">
							<b-button class="fa fa-th" variant="dark" />
						</b-link>
						<vs-dropdown-menu class="columns-dropdown">
							<vs-dropdown-item v-for="(ind, i) in fields" :key="i">
								<b-checkbox v-model="ind.visible">{{ ind.label }}</b-checkbox>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
					<!-- <download-excel v-if="items.length > 0" :data="items" :fields="computedJsonToExcel"
						:disabled="loading" style="cursor: pointer" class="ml-2 btn btn-outline-primary"
						name="Отчет № 5">
						<b-spinner v-if="loading" small class="mr-2" /><strong>Excel</strong>
					</download-excel> -->
					<b-button variant="outline-dark" @click="printPdf" class="mr-2">
						<i class="fa fa-print"></i>
						{{ $t('Печать') }}
					</b-button>
				</b-col>
			</b-row>
			<b-row class="mt-2">
				<b-col>
					<multiselect label="name" track-by="id" :multiple="false" v-model="groupId" :options="groups"
						:allow-empty="true" :group-select="true" :show-labels="false" class="multiselect-pricing"
						:placeholder="$t('goods.create.select-group')" />
				</b-col>
				<b-col>
					<multiselect label="name" track-by="id" :multiple="true" v-model="category" :allow-empty="true"
						:group-select="true" :show-labels="false" :options="categorys" class="multiselect-pricing"
						:placeholder="$t('goods.create.category')" />
				</b-col>
			</b-row>
			<b-row class="mt-2">
				<b-col>
					<b-form-input :placeholder="$t('incomes.create.product')" v-model="itemName" type="text" />
				</b-col>
				<b-col>
					<b-form-input :placeholder="$t('goods.special-barcode')" v-model="barcode" type="text" />
				</b-col>
				<b-col>
					<b-form-input :placeholder="$t('goods.artikul')" v-model="article" type="text" />
				</b-col>
			</b-row>
		</div>
		<b-card-body>
			<b-overlay :show="loading" rounded opacity="0.7">
				<b-table :items="items" :fields="computedFields" :busy="loading" :responsive="true" small bordered
					show-empty striped hover label-sort-asc="" label-sort-desc="" label-sort-clear=""
					id="gridContainer">
					<template v-for="dep in depList" :slot="dep.name" slot-scope="data">
						<b>{{ data }}</b>
					</template>
					<template #table-busy>
						<div class="text-center my-2">
							<b-spinner small class="mr-2" /><strong>Loading...</strong>
						</div>
					</template>
					<template #cell(images)="data">
						<div class="d-flex justify-content-center align-items-center">
							<img v-if="data.item.images && data.item.images.length > 0" style="width: 70px"
								:src="imageUrl + data.item.images[0].id" @click="viewImage(data.item)">
						</div>
					</template>
					<template #cell(index)="data">
						{{ data.index + 1 }}
					</template>
					<template #cell(priceUzs)="data">
						{{ data.item.priceUzs + 'UZS' }}
					</template>

					<template #cell(department)="data">
					</template>
				</b-table>
			</b-overlay>
		</b-card-body>

		<b-modal v-model="fileUploadModal" :title="selectedItem.itemName" size="sm" centered hide-footer>
			<b-container>
				<b-row>
					<b-col v-if="selectedItem && selectedItem.images && selectedItem.images.length > 0"
						class="mb-2 image-wrapper">
						<img class="img-fluid w-100 img-thumbnail mb-2" :src="imageUrl + selectedItem.images[0].id">
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import { BTable, VBTable } from "bootstrap-vue";
import DxDataGrid, { DxColumn, DxExport, DxColumnChooser, DxFilterRow, DxSearchPanel, DxLoadPanel } from "devextreme-vue/data-grid";
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";
import ReportService from "./report.service";
import { BOverlay } from 'bootstrapVue2';
import ReferencesService from "../../../services/references.sevice";
import GoodsService from "../../../services/goods.service";

export default {
	name: "Index",
	components: {
		Multiselect,
		BTable,
		VBTable,
		DxDataGrid,
		DxColumn,
		DxExport,
		DxColumnChooser,
		DxFilterRow,
		DxLoadPanel,
		DxSearchPanel,
		BOverlay,
	},
	data() {
		return {
			fields: [
				{ key: 'index', label: '№', class: 'text-center align-middle', visible: true },
				{ key: 'images', label: this.$t('Изображение товара'), class: 'text-center align-middle', visible: true, sortable: true },
				{ key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center align-middle', visible: true, sortable: true },
				// { key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center align-middle', visible: true, sortable: true },
				{ key: 'itemName', label: this.$t('pos.product'), class: 'text-center align-middle', visible: true, sortable: true },
				{ key: 'priceUzs', label: this.$t('incomes.create.price'), class: 'text-center align-middle', visible: true, sortable: true },
				// { key: 'artikul', label: this.$t('goods.artikul'), class: 'text-center align-middle', visible: true, sortable: true },
				// { key: 'subName', label: this.$t('contragent.group-name'), class: 'text-center align-middle', visible: true, sortable: true },
				{ key: 'remaining', label: this.$t('remaining'), class: 'text-center align-middle', visible: true, sortable: true }
			],
			departmentId: null,
			departmentIds: null,
			depId: null,
			depIds: [],
			groupId: null,
			category: [],
			itemName: '',
			barcode: '',
			article: '',
			groups: [],
			categorys: [],
			groupIds: [],
			departments: [],
			categoryIds: [],
			allDep: false,
			selectedItem: {},
			depDisabled: false,
			fileUploadModal: false,
			items: [],
			depList: [],
			position: { of: "#gridContainer" },
			showIndicator: true,
			shading: true,
			showPane: true,
			closeOnOutsideClick: false,
			loading: false,
		}
	},
	computed: {
		imageUrl() {
			return process.env.VUE_APP_ROOT_API + '/item/photo/'
		},
		computedJsonToExcel() {
			let visibleFields = {};
			this.fields.forEach(t => {
				if (t.visible === true) {
					visibleFields[t.label] = t.key;
				}
			})
			return visibleFields;
		},
		computedFields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible)
					tmp.push(t)
			})
			return tmp
		},
	},
	watch: {
		'groupId': {
			handler(g) {
				if (g) {
					ReferencesService.getCategorysByGroupIds([g.id]).then(res => {
						this.categorys = res.data
					})
				} else {
					this.categorys = []
				}
				this.category = []
			}
		},
		category: {
			handler(c) {
				this.categoryIds = []
				if (c) {
					c.forEach(t => {
						this.categoryIds.push(t.id)
					})
				}
			}
		},
		departmentId: {
			handler(t) {
				if (t)
					this.depId = t.id
				else
					this.depId = null
			}
		},
		departmentIds: {
			handler(t) {
				this.depIds = []
				if (t)
					t.forEach(dep => {
						this.depIds.push(dep.id)
					})
				else
					this.depIds = []
			}
		},
		allDep: {
			handler(t) {
				if (t) {
					this.depIds = []
					if (this.departments.length > 0) {
						this.depDisabled = true
						this.departments.forEach(dep => {
							this.depIds.push(dep.id)
						})
					} else {
						this.$vs.notify({
							title: 'Отделов пока нет !',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					}
				} else {
					this.depDisabled = false
					this.departmentIds = []
					this.departmentId = null
				}
			}
		}
	},
	methods: {
		printPdf() {
			window.print();
		},
		viewImage(item) {
			this.selectedItem = item;
			this.fileUploadModal = true;
		},
		async upload($event) {
			this.loading = true;
			try {
				const fileList = $event.target.files;
				if (!fileList || fileList.length === 0) return;
				const file = fileList[0];
				const form = new FormData();
				form.append('itemId', this.selectedItem.id);
				form.append('upload', file, file.name);

				await GoodsService.uploadPhoto(this.selectedItem.id, form);

				const res = await GoodsService.getItemImages(this.selectedItem.id);
				this.$set(this.selectedItem, 'images', res.data);

				this.$vs.notify({
					title: 'Muvaffaqiyatli yuklandi',
					color: 'success',
					icon: 'check',
					position: 'top-right'
				});
			} catch (e) {
				this.$vs.notify({
					title: e.message || 'Error',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			} finally {
				this.loading = false;
				$event.target.value = '';
			}
		},
		onContentReady(e) {
			e.component.option("loadPanel.enabled", false);
		},
		async getDepartments() {
			await UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getItems() {
			this.loading = true
			let data = {
				fromDepId: this.allDep === false ? this.depId : null,
				toDepIds: this.depIds,
				subCategoryId: this.groupId ? this.groupId.id : null,
				sub2CategoryId: this.category ? this.category.id : null,
				subGroups: this.categoryIds,
				sub3CategoryId: null,
				value: this.itemName,
				barcode: this.barcode,
				article: this.article
			}
			ReportService.getReportItems(data).then(res => {
				if (res.data && res.data.length > 0) {
					this.depList = []
					this.departments.forEach(dep => {
						this.fields.forEach((f, i) => {
							if (dep.name === f.key)
								this.fields.splice(i, 1)
						})
						this.depIds.forEach(d => {
							if (d == dep.id)
								this.depList.push(dep)
						})
						if (this.depId == dep.id)
							this.depList.unshift(dep)
					})
					this.depList.forEach(dep => {
						this.fields.push(
							{ key: dep.name, label: dep.name, class: 'text-center align-middle', visible: true, sortable: true }
						)
					})
					if (this.allDep) {
						this.departmentIds = []
						this.departmentId = null
					}
					this.items = res.data
				} else {
					this.items = []
					this.depList = []
				}
				this.loading = false
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			})
		},
		print() {
			window.print();
		},
		disableOption(dep) {
			this.departments.forEach(d => {
				d.disabled = d.id === dep.id;
			})
			this.$forceUpdate()
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function (s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function (s, c) {
					return s.replace(/{(\w+)}/g, function (m, p) {
						return c[p];
					})
				}
			this.fields.forEach(t => {
				delete t.sortable
			})
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		excelExport(tableID, filename = '') {

			var downloadLink;

			// var dataType = 'text/xls;charset=UTF-8';
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename ? filename + '.xls' : 'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if (navigator.msSaveOrOpenBlob) {
				var blob = new Blob(['\ufeff', tableSelect], {
					encoding: "utf-8",
					type: dataType
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				// Create a link to the file
				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

				// Setting the file name
				downloadLink.download = filename;

				//triggering the function
				downloadLink.click();
			}
		}
	},
	async created() {
		await ReferencesService.getSubReferenceChildren(14).then(res => {
			this.groups = res.data
		})
		await this.getDepartments();
	}
}
</script>

<style scoped>
.image-wrapper {
	position: relative;
}

@media print {
	.hidden-print {
		display: none;
	}

	.nav {
		display: none;
	}

	.nav-pills {
		display: none;
	}

	.flex-column {
		display: none;
	}

	* {
		overflow: hidden;
	}
}
</style>
